import React, { Component } from "react";
import { connect } from "react-redux";
import Timer from "./Timer";
import axios from "axios";

import config from "./../config/config-secret.json";

import {
  previousQuestion,
  setRemainingTime,
  setTimeExpired,
  nextExam,
  changeView,
  resetDataEntryForm,
  previousOpenQuestion,
  setOpenQuestionAnswerText,
  resetTempDataEntryData,
} from "./../actions/assessment";

// import logo from "./../assets/img/psymetrics-new-logo.svg";
import logo from "./../assets/img/psymetrics-logo-horizontal-black.svg";
import backIcon from "./../assets/img/icon-back.svg";

import { Translate } from "react-redux-i18n";
import Button from "./ui/Buttons/Button";

export class Header extends Component {
  state = {
    logo: logo,
    logoClass: "logo",
  };

  componentDidMount = async () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let key = params.get("key");
    let code = params.get("code");

    await this.getLogo(key, code);
  };

  getLogo = async (key_code, invite_code) => {
    await axios
      .get(
        config.API_DOMAIN +
          `/v2/examination/get_logo/?invite_code=${invite_code}&key_code=${key_code}`,
      )
      .then((res) => {
        const response = res.data;
        const logo = response.data.logo;

        if (logo) {
          this.setState({
            logo: config.API_DOMAIN + "/api_media/" + logo,
            logoClass: "custom-logo",
          });
        }
      });
  };

  end_practice = () => {
    let exams = this.props.assessment.exams;
    let exam_name = exams[this.props.assessment.exam_index].name;
    if (
      [
        "Typing Test V1",
        "Typing Test V2",
        "Data Entry V1",
        "Data Entry V2",
      ].includes(exam_name)
    ) {
      exams[this.props.assessment.exam_index].is_practice_done = true;
      this.props.assessment.is_typing_started = false;
      this.props.assessment.start_time = 0;
      this.props.resetDataEntryForm();
      this.props.show_typing_instruction();
    }
  };

  go_back_typing_instruction = () => {
    this.props.assessment.status = 0;
    this.props.show_typing_instruction();
  };

  previousOpenQuestion(current_oq_index) {
    const oq_answer = this.props.open_questions_answers;
    const previousAnswerValue = oq_answer?.[current_oq_index - 1]
      ? oq_answer[current_oq_index - 1]
      : "";
    this.props.setAnswerText(previousAnswerValue);

    this.props.previousOpenQuestion(current_oq_index);
  }

  render() {
    const i18n = require("react-redux-i18n").I18n;
    const { current_oq_index } = this.props;
    // const STARTED = 0;
    const ONGOING = 1;

    return (
      <nav className="topbar fixed-top d-flex">
        <div className="align-self-center w-100">
          <div className="row mt-xs-0">
            <div className="col-lg-4 col-md-3 col-sm-12 col-xs-12 align-self-center">
              <div className="row">
                <div className="col-6 align-self-center order-sm-1">
                  <img
                    style={{ maxWidth: "180px" }}
                    src={this.state.logo}
                    alt="Logo"
                    className={this.state.logoClass}
                  />
                </div>
                {this.props.view === "job_application_form2" && (
                  <div className="col-6 align-self-center order-sm-2 d-flex flex-row-reverse">
                    {/* <button
                      className="btn btn-main prev previous-sm-btn "
                      onClick={this.props.show_job_application_form1}
                    >
                      <img src={backIcon} alt={i18n.t("back")} />
                      <span className="prev-text">
                        {" "}
                        <Translate value="prev" />
                      </span>
                    </button> */}
                    <Button
                      variant="primary"
                      className="prev previous-sm-btn"
                      onClick={this.props.show_job_application_form1}
                    >
                      <img src={backIcon} alt={i18n.t("back")} />
                      <span className="prev-text">
                        {" "}
                        <Translate value="prev" />
                      </span>
                    </Button>
                  </div>
                )}
              </div>
            </div>
            {this.props.view === "job_application_form2" && (
              <div className="previous-btn col-lg-4 col-md-3 col-sm-3 col-12 align-self-center order-sm-2 order-md-12 d-flex flex-row-reverse">
                <div className="nav-r">
                  {/* <button
                    className="btn btn-main prev"
                    onClick={this.props.show_job_application_form1}
                  >
                    <img src={backIcon} alt={i18n.t("back")} />
                    <span className="prev-text">
                      {" "}
                      <Translate value="prev" />
                    </span>
                  </button> */}
                  <Button
                    variant="primary"
                    className="prev"
                    onClick={this.props.show_job_application_form1}
                  >
                    <img src={backIcon} alt={i18n.t("back")} />
                    <span className="prev-text">
                      {" "}
                      <Translate value="prev" />
                    </span>
                  </Button>
                </div>
              </div>
            )}

            {this.props.view === "practice_test" && (
              <>
                <div className="col-4 align-self-center order-sm-2 order-md-12">
                  <p className="tester-name">{this.props.full_name}</p>
                </div>
                <div className="previous-btn col-4 align-self-center order-sm-2 order-md-12 d-flex flex-row-reverse">
                  <div className="nav-r">
                    {this.props.data_entry.form_index === 0 && (
                      // <button
                      //   className="btn btn-main prev"
                      //   onClick={this.props.show_typing_instruction}
                      // >
                      //   <img src={backIcon} alt={i18n.t("back")} />
                      //   <span className="prev-text">
                      //     {" "}
                      //     <Translate value="prev" />
                      //   </span>
                      // </button>
                      <Button
                        variant="primary"
                        className="prev"
                        onClick={this.props.show_typing_instruction}
                      >
                        <img src={backIcon} alt={i18n.t("back")} />
                        <span className="prev-text">
                          {" "}
                          <Translate value="prev" />
                        </span>
                      </Button>
                    )}
                    {/* <button
                      className="btn btn-main btn-end mr-2"
                      onClick={() => {
                        this.end_practice();
                        this.props.resetTempDataEntryData();
                      }}
                    >
                      End Practice Test
                    </button> */}
                    <Button
                      variant="primary"
                      className="btn-end mr-2"
                      onClick={() => {
                        this.end_practice();
                        this.props.resetTempDataEntryData();
                      }}
                    >
                      End Practice Test
                    </Button>
                    <Timer />
                  </div>
                </div>
              </>
            )}

            {["job_application_form1", "job_application_form2"].includes(
              this.props.view,
            ) && (
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 align-self-center order-sm-2">
                <hr className="xs-div" />
                <div className="row align-items-end py-md-3 px-4">
                  <div className="col-md-12 col-12">
                    <p className="tester-name">{this.props.full_name}</p>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width:
                            this.props.view === "job_application_form1"
                              ? "0%"
                              : this.props.is_certified
                                ? "100%"
                                : "50%",
                        }}
                        aria-valuenow={
                          this.props.view === "job_application_form1"
                            ? "0"
                            : this.props.is_certified
                              ? "100"
                              : "50"
                        }
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {this.props.view === "job_application_form1"
                          ? "0"
                          : this.props.is_certified
                            ? "100"
                            : "50"}
                        %
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {[ONGOING].includes(this.props.status) && (
              <>
                {this.props.view === "examination" && (
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12 align-self-center order-sm-2 order-md-12 d-flex flex-row-reverse">
                    <div className="nav-r">
                      {/* The Previous button comes and goes, but the Timer must
                          stay mounted: unmounting it stops the countdown and
                          restarts the section clock when it comes back. */}
                      {this.props.show_previous_button && (
                        <Button
                          variant="primary"
                          className="prev"
                          onClick={this.props.previousQuestion}
                        >
                          <img src={backIcon} alt={i18n.t("back")} />
                          <span className="prev-text">
                            {" "}
                            <Translate value="prev" />
                          </span>
                        </Button>
                      )}
                      <Timer />
                    </div>
                  </div>
                )}
                {this.props.show_previous_button &&
                  ["typing_test", "data_entry_test"].includes(
                    this.props.view,
                  ) && (
                    <div className="col-4 align-self-center order-sm-2 order-md-12">
                      <p className="tester-name">{this.props.full_name}</p>
                    </div>
                  )}
              </>
            )}

            {[ONGOING].includes(this.props.status) &&
              ["typing_test", "data_entry_test"].includes(this.props.view) && (
                <div className="col-lg-4 col-md-4 col-sm-12 col-12 align-self-center order-sm-2 order-md-12 d-flex flex-row-reverse">
                  <div className="nav-r">
                    {this.props.data_entry.form_index === 0 && (
                      // <button
                      //   className="btn btn-main prev"
                      //   onClick={this.go_back_typing_instruction}
                      // >
                      //   <img src={backIcon} alt={i18n.t("back")} />
                      //   <span className="prev-text">
                      //     {" "}
                      //     <Translate value="prev" />
                      //   </span>
                      // </button>
                      <Button
                        variant="primary"
                        className="prev"
                        onClick={this.go_back_typing_instruction}
                      >
                        <img src={backIcon} alt={i18n.t("back")} />
                        <span className="prev-text">
                          {" "}
                          <Translate value="prev" />
                        </span>
                      </Button>
                    )}
                    <Timer />
                  </div>
                </div>
              )}

            {[ONGOING].includes(this.props.status) &&
              !["typing_test", "data_entry_test", "instruction"].includes(
                this.props.view,
              ) && (
                <div className="col-lg-4 col-md-5 col-sm-12 col-xs-8  align-self-center order-sm-3">
                  <hr className="xs-div" />
                  <div className="row align-items-end py-md-3 px-4">
                    <div className="col-md-12 col-12">
                      <p className="tester-name">{this.props.full_name}</p>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: this.props.progress_percentage + "%",
                          }}
                          aria-valuenow={this.props.progress_percentage}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {this.props.progress_percentage}%
                        </div>
                      </div>
                      <p className="message">
                        <Translate value={this.props.progress_label} />
                      </p>
                    </div>
                  </div>
                </div>
              )}

            {["open_question_form1"].includes(this.props.view) && (
              <div className="col-lg-4 col-md-5 col-sm-12 col-xs-8  align-self-center order-sm-3">
                <hr className="xs-div" />
                <div className="row align-items-end py-md-3 px-4">
                  <div className="col-md-12 col-12">
                    <p className="tester-name">{this.props.full_name}</p>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: this.props.progress_percentage + "%",
                        }}
                        aria-valuenow={this.props.progress_percentage}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {this.props.progress_percentage}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {["open_question_form1"].includes(this.props.view) && (
              <div className="col-lg-4 col-md-4 col-sm-12 col-12 align-self-center order-sm-2 order-md-12 d-flex flex-row-reverse">
                <div className="nav-r">
                  {this.props.show_previous_button && (
                    // <button
                    //   className="btn btn-main prev"
                    //   onClick={() =>
                    //     this.previousOpenQuestion(current_oq_index)
                    //   }
                    // >
                    //   <img src={backIcon} alt={i18n.t("back")} />
                    //   <span className="prev-text">
                    //     {" "}
                    //     <Translate value="prev" />
                    //   </span>
                    // </button>
                    <Button
                      variant="primary"
                      className="prev"
                      onClick={() =>
                        this.previousOpenQuestion(current_oq_index)
                      }
                    >
                      <img src={backIcon} alt={i18n.t("back")} />
                      <span className="prev-text">
                        {" "}
                        <Translate value="prev" />
                      </span>
                    </Button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  show_previous_button: state.assessment.show_previous_button,
  view: state.assessment.view,
  full_name: state.assessment.first_name + " " + state.assessment.last_name,
  status: state.assessment.status,
  progress_percentage: state.assessment.progress_percentage,
  progress_label: state.assessment.progress_label,
  has_job_application: state.assessment.has_job_application,
  is_certified: state.assessment.is_certified,
  data_entry: state.assessment.data_entry,
  current_oq_index: state.assessment.current_oq_number,
  open_questions_answers: state.assessment.open_questions_answers,
  answer_text: state.assessment.current_oq_answer_text,
});

const mapDispatchToProps = (dispatch) => ({
  setTimeExpired: (is_time_expired) =>
    dispatch(setTimeExpired(is_time_expired)),
  previousQuestion: () => dispatch(previousQuestion()),
  nextExam: () => dispatch(nextExam()),
  setRemainingTime: () => dispatch(setRemainingTime()),
  show_job_application_form1: () =>
    dispatch(changeView("job_application_form1")),
  previousOpenQuestion: (current_oq_index) =>
    dispatch(previousOpenQuestion(current_oq_index)),
  setAnswerText: (text) => dispatch(setOpenQuestionAnswerText(text)),
  show_typing_instruction: () => dispatch(changeView("instruction")),
  resetDataEntryForm: () => dispatch(resetDataEntryForm()),
  resetTempDataEntryData: () => dispatch(resetTempDataEntryData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
